import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { LoadingButton } from '@material-ui/lab';
import { CSVLink } from "react-csv";
import {
    Grid,
    TextField,
} from "@material-ui/core";

function LeadsReports() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState({
        startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
        endDate: new Date().toISOString().slice(0, 10)
    });

    const headers = [
        { label: 'Call Date & Time', key: "date" },
        { label: 'Contact No.', key: "phoneNumber" },
        { label: 'Seller Name', key: "sellerName" },
        { label: 'Product Category', key: "productCategory" },
        { label: 'Alternate No.', key: "alternateNumber" },
        { label: 'City Name', key: "city" },
        { label: 'State Name', key: "state" },
        { label: 'Call Status', key: "callStatus" },
        { label: 'Call Remarks', key: "callRemark" },
        { label: 'Agent ID', key: "agentId" },
        { label: 'Agent Name', key: "agentName" },
    ]



    const LoadData = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_PATH}/sales/getAllCallReports?startDate=${date.startDate}&endDate=${date.endDate}`).then(res => {
            if (res.data.success) {
                res.data.data.forEach((item)=>{
                    item.date= moment(item.createdAt).format('DD-MM-YYYY,hh:mm')
                })
                setData(res?.data?.data || []);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            alert("Something Went Wrong", err)
        })
    }
    useEffect(() => {
        LoadData();
    }, [])


    return (
        <>
            <Grid container spacing={4} item alignItems="center" >
                <Grid xs={12} lg={3} item>
                    <TextField
                        id="datetime-local"
                        label="Start Date"
                        type="date"
                        defaultValue={date.startDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{
                            width: "100%",
                        }}
                        onChange={(e) =>
                            setDate({
                                ...date,
                                startDate: e.target.value,
                            })
                        }
                    />
                </Grid>
                <Grid xs={12} lg={3} item>
                    <TextField
                        id="datetime-local"
                        label="End Date"
                        type="date"
                        defaultValue={date.endDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{
                            width: "100%",
                        }}
                        onChange={(e) =>
                            setDate({
                                ...date,
                                endDate: e.target.value,
                            })
                        }
                    />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        onClick={LoadData}
                    >
                        <span>Submit</span>
                    </LoadingButton>
                </Grid>
                <Grid item xs={12} lg={3}>
                  {data.length>0&&!loading &&<CSVLink data={data} headers={headers} filename={"Agents Lead Report"} style={{ textDecoration: 'none', border: '1px solid #999', padding: '10px 20px', backgroundColor: '#95c7f1' }} >Download</CSVLink>}
                </Grid>
            </Grid>
          
        </>
    )
}

export default LeadsReports